"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gallery = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _ReactIdSwiper = _interopRequireDefault(require("react-id-swiper/lib/ReactIdSwiper.custom"));
var _Arrow = require("b2b-components/theme/components/Gallery/Arrow");
var _Modal = require("b2b-components/theme/components/Modal");
var _classnames = _interopRequireDefault(require("classnames"));
var _swiper = _interopRequireWildcard(require("swiper"));
require("./Gallery.scss");
require("swiper/swiper-bundle.min.css");
require("swiper/swiper.min.css");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Gallery = function Gallery(_ref) {
  var className = _ref.className,
    images = _ref.images,
    isModalOpened = _ref.isModalOpened,
    onModalClose = _ref.onModalClose,
    onModalOpen = _ref.onModalOpen,
    title = _ref.title;
  var gallerySwiperRef = (0, _react.useRef)(null);
  var modalSwiperRef = (0, _react.useRef)(null);
  if (!images || !Array.isArray(images)) {
    return null;
  }
  var text = {
    ariaLabel: 'Gallery',
    ariaCloseModal: 'Close Gallery'
  };
  var params = {
    Swiper: _swiper["default"],
    modules: [_swiper.Navigation, _swiper.Pagination],
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction'
    },
    keyboard: {
      enabled: true
    },
    navigation: {
      nextEl: ".".concat(_Arrow.ARROW_CLASS_NAME_NEXT),
      prevEl: ".".concat(_Arrow.ARROW_CLASS_NAME_PREV)
    },
    renderNextButton: function renderNextButton() {
      return /*#__PURE__*/_react["default"].createElement(_Arrow.Arrow, {
        type: _Arrow.ARROW_TYPE.next,
        className: "cds-cms-GalleryArrow"
      });
    },
    renderPrevButton: function renderPrevButton() {
      return /*#__PURE__*/_react["default"].createElement(_Arrow.Arrow, {
        type: _Arrow.ARROW_TYPE.prev,
        className: "cds-cms-GalleryArrow"
      });
    },
    spaceBetween: 30
  };
  var rootClassName = (0, _classnames["default"])('cds-cms-Gallery', className);
  var renderModalBody = function renderModalBody() {
    var _gallerySwiperRef$cur, _gallerySwiperRef$cur2;
    var modalInitialSlide = (gallerySwiperRef === null || gallerySwiperRef === void 0 ? void 0 : (_gallerySwiperRef$cur = gallerySwiperRef.current) === null || _gallerySwiperRef$cur === void 0 ? void 0 : (_gallerySwiperRef$cur2 = _gallerySwiperRef$cur.swiper) === null || _gallerySwiperRef$cur2 === void 0 ? void 0 : _gallerySwiperRef$cur2.realIndex) || 0;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: rootClassName
    }, title && /*#__PURE__*/_react["default"].createElement("h5", {
      className: "cds-cms-GalleryTitle"
    }, title), /*#__PURE__*/_react["default"].createElement(_ReactIdSwiper["default"], (0, _extends2["default"])({}, params, {
      ref: modalSwiperRef,
      initialSlide: modalInitialSlide
    }), images.map(function (image, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "cds-cms-GallerySlideWrapper",
        key: index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "cds-cms-GallerySlide"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        key: index,
        alt: image.title,
        className: "cds-cms-GalleryImage",
        onClick: onModalOpen,
        src: image.url
      }), !!image.caption && /*#__PURE__*/_react["default"].createElement("span", {
        className: "cds-cms-GalleryCaption"
      }, image.caption)));
    })));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, title && /*#__PURE__*/_react["default"].createElement("h5", {
    className: "cds-cms-GalleryTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-cms-GallerySliderWrapper"
  }, /*#__PURE__*/_react["default"].createElement(_ReactIdSwiper["default"], (0, _extends2["default"])({}, params, {
    ref: gallerySwiperRef
  }), images.map(function (image, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "cds-cms-GallerySlideWrapper",
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "cds-cms-GallerySlide"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      key: index,
      alt: image.title,
      className: "cds-cms-GalleryImage",
      onClick: onModalOpen,
      src: image.url
    }), !!image.caption && /*#__PURE__*/_react["default"].createElement("span", {
      className: "cds-cms-GalleryCaption"
    }, image.caption)));
  }))), /*#__PURE__*/_react["default"].createElement(_Modal.Modal, {
    animationType: _Modal.MODAL_ANIMATION_TYPE.fade,
    content: renderModalBody,
    isOpen: isModalOpened,
    onCloseModal: onModalClose,
    text: {
      ariaLabel: text.ariaLabel,
      ariaCloseModal: text.ariaCloseModal
    },
    type: _Modal.MODAL_TYPE.fullscreen
  }));
};
exports.Gallery = Gallery;